class PairItWith extends window.BAO.ProductForm {
  static get requiredElements () {
    return ['checkbox', 'total', 'add']
  }

  setupListeners () {
    super.setupListeners()
    this.handleFormChange = this.handleFormChange.bind(this)
    this.listeners.add(this.form, 'change', this.handleFormChange)
  }

  handleFormChange () {
    this.updateTotal()
    this.updateItemCount()
  }

  updateTotal () {
    this.totalEl.textContent = window.BAO.Utils.formatMoney(this.total)
  }

  updateItemCount () {
    this.addToCartEl.textContent = this.addToCartTranslation.replace(
      '[[count]]',
      this.selectedCheckboxEls.length,
    )
  }

  get total () {
    return this.selectedCheckboxEls.length
      ? this.selectedCheckboxEls
        .map(checkboxEl => parseInt(checkboxEl.dataset.price, 10))
        .reduce((previousValue, currentValue) => previousValue + currentValue)
      : 0
  }

  get checkboxEls () {
    return this.els?.checkbox?.elements || []
  }

  get totalEl () {
    return this.els?.total?.element
  }

  get addToCartEl () {
    return this.els?.add?.element
  }

  get addToCartTranslation () {
    return this.dataset?.translationAddItemsToCart || ''
  }

  get selectedCheckboxEls () {
    return this.checkboxEls.filter(checkboxEl => checkboxEl.checked)
  }
}

if (!customElements.get('pair-it-with')) {
  customElements.define('pair-it-with', PairItWith)
}
